import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { twMerge } from "tailwind-merge";
import { EVENT_PATH } from "../App";
import { useTranslation } from "react-i18next";

export function EventCard({ index, event, type }) {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const handleClick = () => {
        navigate(EVENT_PATH.replace(":id", event?.id ?? ""), {
            state: event,
        });
    };
    return (
        <div className="flex-center gap-2 mb-2 sticky left-0" key={index}>
            <div
                className={twMerge(
                    "w-full overflow-hidden",
                    index === 0 ? "bg-black" : ""
                )}
            >
                <p className="event-type text-end uppercase font-bold w-full h-6">
                    {index === 0 ? t(`event.${type.toLowerCase()}`) : ""}
                </p>
            </div>
            <button onClick={handleClick} className="w-full h-full">
                <div className="event-photo-container border-2 p-4 overflow-hidden bg-black shadow-black shadow-lg hover:scale-[1.01] aspect-[4/5] relative w-full h-full flex justify-center items-center">
                    <img
                        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full object-center object-cover blur-md opacity-30"
                        src={event?.coverImage}
                        alt="poster"
                    />
                    <img
                        className="relative h-full object-center object-contain max-w-[66vw] md:max-w-[33vw] lg:max-w-[22vw]"
                        src={event?.coverImage}
                        alt="poster"
                    />
                </div>
            </button>
            <div className="w-full overflow-hidden bg-black">
                <p className="event-title text-start uppercase font-bold max-w-[66vw] md:max-w-[33vw] lg:max-w-[22vw] h-6 truncate">
                    {event?.name ?? t("event.unknown")}
                </p>
            </div>
        </div>
    );
}
